
function refreshSets() {
    // WorldWide Global DropDown


    $.get( 'https://ultramusicfestival.com/livestream-2018?json=1' , function() {})
    .done(function(data) {

        var n1url = data.settimes_banner_image;        // new url
        var c1url = $('a.channel1').data('setimg');    // channel 1 url

        if(n1url != c1url) {
            $('a.channel1').attr('data-vidlink', n1url)
            $('.settimesimage').attr('src',n1url);
            $('.settimeslink').attr('href',n1url);
            //log('set banner 1 changed');
        } else {
            //log('no change');
        }

        setTimeout(function(){ refreshSets(); }, 60000);

        /*
        var n1url = data.liveurl;
        var c1url = $('a.channel1').data('vidlink');

        var n2url = data.resistance_as;
        var c2url = $('a.channel2').data('vidlink');

        var n3url = data.resistance_cc;
        var c3url = $('a.channel3').data('vidlink');

        if(n1url != c1url) {
            $('a.channel1').attr('data-vidlink', n1url)
            log('set banner 1 changed');
        }
        if(n2url != c2url) {
            $('a.channel2').attr('data-vidlink', n2url)
            log('set banner 2 changed');
        }
        if(n3url != c3url) {
            $('a.channel3').attr('data-vidlink', n3url)
            log('set banner 3 changed');
        }

        if( $('a.channel1.active').length ) {
            $('#ls-video>div>iframe').attr('src', n1url);
        } else if( $('a.channel1.active').length ) {
            $('#ls-video>div>iframe').attr('src', n1url);

        }
        */

    });
}
function ls2018() {

    if ( !$('.newlsbtn').length ) {
        return;
    }

    //refreshSets();

    $('.newlsbtn').on('click', function(e){

        e.preventDefault();
        var el = $(this);

        var width = $(document).width();

        var setimg = el.data('setimg');  //="<?=$settimes_banner_image?>"
        var vidlink = el.data('vidlink');  //="<?=$u_live_url?>"
        var sitebg = el.data('sitebg');  //="<?=$ulivebg?>"
        var mobilebg = el.data('mobilebg');  //="<?=$mobilebg?>"
        var schedulebtn = el.data('schedulebtn');  //="<?=$mobilebg?>"
        var type = el.data('type');  //="ultra"

        var hash = el.data('hash');
        var newhashlink = '';
        var currenthashlink = $('.sharehash a').attr('href');

        if(hash == 'JoinTheResistance') {
            newhashlink = currenthashlink.replace('ultralive','jointheresistance');
        } else {
            newhashlink = currenthashlink.replace('jointheresistance','ultralive');

        }
        $('.sharehash a').text('#'+hash);
        $('.sharehash a').attr('title', hash);
        $('.sharehash a').attr('href', newhashlink);

        $('#ls-video>div>iframe').attr('src', vidlink);

        $('.newlsbtn.active').removeClass('active');
        el.addClass('active');


        $('.settimesimage').attr('src',setimg);

        $('.settimeslink').attr('href',setimg);
        $('.fschbtn').find('img').attr('src',schedulebtn);

        $('.ad-banners').append('<a target="_blank" class="resisonlybanner" href="https://resistanceibiza.com/lineup"><img src="https://umfworldwide.com/wp-content/uploads/2016/05/resistance-ibiza-banner-thin-tickets-2018.jpg" alt="" width="850"></a>');

        // manage actives
        if(type == 'resistance') {
            $('.ad-banners ul, .ad-banners .cycler-nav').fadeTo(300,0);
            $('.resisonlybanner').fadeIn(300);
            $('#ls-header').find('.uliveh').hide();
            $('#ls-header').find('.resistanceh').show();
            $('em.newa').find('img').attr('src', 'https://ultramusicfestival.com/wp-content/uploads/2018/03/active-resis.png');
            $('.umf-tv-desk').attr('src', 'https://ultraeurope.com/wp-content/uploads/2018/07/umf-tv-resistance.png')
        } else {
            $('.resisonlybanner').fadeOut(300);
            $('.ad-banners ul, .ad-banners .cycler-nav').fadeTo(300,1);
            $('#ls-header').find('.resistanceh').hide();
            $('#ls-header').find('.uliveh').show();
            $('em.newa').find('img').attr('src', 'https://ultramusicfestival.com/wp-content/uploads/2018/03/active.png');
            $('.umf-tv-desk').attr('src', 'https://ultramusicfestival.com/wp-content/uploads/2017/03/umf-tv-desktop.png')
        }


        // manage backgrounds
        if(width > 1000) {
            $('#ls-header').css({'height': '100px'});
            $('#newgridbg div.bg2').css({'background-size': 'auto'});
            $('#newgridbg div.bg2').css({'background-image': `url(${sitebg})`});
            if(type == 'resistance') {
                $('#newgridbg div.bg2').css({'background-position': 'top center'});
            } else {
                $('#newgridbg div.bg2').css({'background-position': 'center -451px'});
            }
        } else {

            $('#newgridbg div.bg2').css({'background-image': `url(${mobilebg})`});
            if(type == 'resistance') {
                $('#newgridbg div.bg2').css({'background-position': 'top center'});
                $('#newgridbg div.bg2').css({'background-size': 'cover'});
                $('#ls-header').css({'height': '100px'});
            } else {
                $('#newgridbg div.bg2').css({'background-size': '800px auto'});
                $('#newgridbg div.bg2').css({'background-position': 'center -190px'});
                $('#ls-header').css({'height': '100px'});
            }
        }
        /**/

    });



    if(window.location.hash == '#resistance') {
        $('.desknav  .channel2').trigger('click');
    }


}
